import dayjs from "dayjs";

export const CRITICAL_DATE_OFFSETS_FROM_CUTOFF = {
  ETD: 5,
  "CUT-OFF": 0,
  ETDF: 0,
  ExFD: -1,
  "Inspection date": -8,
};

export function isCriticalTimelineTask(taskName) {
  return Object.prototype.hasOwnProperty.call(
    CRITICAL_DATE_OFFSETS_FROM_CUTOFF,
    taskName,
  );
}

export function shouldAutoRecalculateCriticalDates(taskName, field, formattedValue) {
  return (
    isCriticalTimelineTask(taskName) &&
    field !== "RealDate" &&
    formattedValue != null &&
    String(formattedValue).trim() !== ""
  );
}

/**
 * Recalcula fechas críticas relativas a CUT-OFF cuando el usuario edita una de ellas.
 * @returns {{ task, payload }[]}
 */
export function buildRecalculatedCriticalDatePayloads(
  timeline,
  taskName,
  field,
  formattedValue,
  { allowOverwriteExpected = true, unlockedExpectedIds = null } = {},
) {
  if (!shouldAutoRecalculateCriticalDates(taskName, field, formattedValue)) {
    return [];
  }

  const changedOffset = CRITICAL_DATE_OFFSETS_FROM_CUTOFF[taskName];
  const cutoffBase = dayjs(formattedValue).subtract(changedOffset, "day");
  const isUnlocked = (taskId) =>
    Boolean(
      unlockedExpectedIds &&
        (unlockedExpectedIds.has(taskId) ||
          unlockedExpectedIds.has(String(taskId))),
    );

  return (Array.isArray(timeline) ? timeline : [])
    .filter((t) => isCriticalTimelineTask(t?.TaskName))
    .filter((t) => {
      if (allowOverwriteExpected || field !== "ExpectedDate") return true;
      if (t.TaskName === taskName) return true;
      if (isUnlocked(t?.Id)) return true;
      return !t?.ExpectedDate;
    })
    .map((t) => {
      const calculatedDate = cutoffBase
        .add(CRITICAL_DATE_OFFSETS_FROM_CUTOFF[t.TaskName], "day")
        .format("YYYY-MM-DD");
      return {
        task: t,
        payload: {
          ...t,
          [field]: calculatedDate,
        },
      };
    });
}
